/**
 * Eligibility 1041 — BDU Eligibility Criteria
 * Heading + gradient rule + one tinted panel with a leading glyph.
 *
 * The `eligibility` table has no gradient pair of its own, so the heading rule reuses
 * the existing `background_gradient_*` columns rather than adding new ones. The labels
 * below say what they actually drive in this variant.
 */

export const ELIGIBILITY_1041_CONSTANTS = {
  ELIGIBILITY_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "Eligibility Criteria",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Eligibility Criteria",
    },
    {
      fieldName: "title_text_color",
      label: "Heading colour",
      value: "#222023",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#222023",
    },
    {
      fieldName: "background_gradient_start_color",
      label: "Rule under heading — start",
      value: "#FF0013",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FF0013",
    },
    {
      fieldName: "background_gradient_end_color",
      label: "Rule under heading — end",
      value: "#990013",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#990013",
    },
    {
      fieldName: "background_gradient_angle",
      label: "Rule under heading — angle",
      value: "90deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "90deg",
      defaultValue: "90deg",
    },
    {
      fieldName: "description",
      label: "Criteria copy",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Any UG Degree of this University or an equivalent examination…",
      defaultValue: "",
      rows: 4,
    },
    {
      fieldName: "description_text_color",
      label: "Criteria copy colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "background_color",
      label: "Criteria panel fill",
      value: "#836537",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#836537",
    },
    {
      fieldName: "button_icon",
      label: "Panel glyph (optional)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon (28x28) — the panel renders without one if empty",
      defaultValue: "",
    },
    {
      fieldName: "button_icon_alt",
      label: "Panel glyph alt",
      value: "Eligibility",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Eligibility",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
